export default __webpack_public_path__ + "static/paris-2706e1e8f54f6eabf70d78d43b7f9fa8.jpg";